import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { Component, Inject } from '@angular/core';
// Rebuild trigger
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SecurityService } from '../../../security/security.service';

@Component({
  selector: 'app-admin-edit-user',
  template: `
    <h2 mat-dialog-title>Edit User: {{data.loginId}}</h2>
    <mat-dialog-content>
      <form [formGroup]="form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Login ID (Email)</mat-label>
          <input matInput formControlName="loginId" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>New Password (Optional)</mat-label>
          <input matInput formControlName="password" placeholder="Leave blank to keep current">
        </mat-form-field>

        <div class="checkbox-container">
            <mat-checkbox formControlName="emailVerified">Email Verified</mat-checkbox>
        </div>

      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-raised-button color="primary" [disabled]="!form.valid || loading" (click)="save()">
        {{loading ? 'Saving...' : 'Save'}}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .full-width { width: 100%; margin-bottom: 10px; }
    .checkbox-container { margin-bottom: 20px; }
  `],
  standalone: true,
  imports: [CommonModule, MaterialModule, ReactiveFormsModule]
})
export class AdminEditUserComponent {
  form: FormGroup;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<AdminEditUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private http: HttpClient,
    private securityService: SecurityService
  ) {
    this.form = this.fb.group({
      id: [data.id],
      loginId: [data.loginId, Validators.required],
      password: [''], // Optional
      emailVerified: [data.emailVerified]
    });
  }

  save() {
    if (this.form.invalid) return;

    this.loading = true;
    const updateData = this.form.value;

    // Construct the payload expected by UserController.updateUser
    // It expects a User object
    const payload = { ...this.data, ...updateData };

    // Only verify if password is changed, otherwise don't send it or send null
    if (!updateData.password) {
      delete payload.password;
      // Note: The backend checks: "if (password != null && !password.isEmpty())"
    }

    const token = this.securityService.getAuthToken();
    const headers = { headers: { Authorization: token } };

    this.http.put(`${this.securityService.apiURL}/user`, payload, headers)
      .subscribe({
        next: () => {
          this.loading = false;
          this.dialogRef.close(true);
        },
        error: (err) => {
          console.error('Failed to update user', err);
          alert('Failed to update user: ' + (err.error?.message || err.message));
          this.loading = false;
        }
      });
  }
}
